import React from "react";

export default function Projects() {
  const projects = [
    { name: "MDC - MDO & FDC Buildings", lbs: "413,941" },
    { name: "ETTE HOTEL - KISSIMMEE", lbs: "139,054" },
    { name: "PINECREST ACADEMY - TAVARES", lbs: "154,044" },
    { name: "CALI COFFEE - PALM HARBOR", lbs: "13,118" },
    { name: "CHIPOTLE - LUTZ, FL", lbs: "5,805" },
    { name: "S GOMEZ TOWNHOUSES", lbs: "113,498" },
    { name: "LAKE MARY RETAIL VANILLA BOX", lbs: "67,382" },
    { name: "GREENLANE - LUTZ, FL", lbs: "4,634" },
    { name: "TAMPA HONDA REMODEL", lbs: "2,735" },
    { name: "FREEDOM ELEMENTARY", lbs: "1,613" },
  ];

  return (
    <div className="bg-gray-50">
      <section className="bg-gradient-to-r from-slate-800 to-slate-700 py-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="flex justify-center items-center gap-4 mb-6">
            <div className="w-20 h-[2px] bg-amber-400"></div>
            <span className="uppercase tracking-[5px] text-amber-400 font-semibold">Our Portfolio</span>
            <div className="w-20 h-[2px] bg-amber-400"></div>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white">Our Projects</h1>
          <p className="mt-8 max-w-4xl mx-auto text-lg text-gray-200 leading-8">
            Since 2019, EDRS has successfully completed <span className="font-bold text-white">500+ projects </span>
            with more than <span className="font-bold text-amber-400">60,000 tons</span> of reinforcing steel estimation and detailing work across commercial, residential and infrastructure developments.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            <Stat number="600+" label="Projects Completed" />
            <Stat number="60,000+" label="Tons Estimated" />
            <Stat number="100%" label="Client Satisfaction" />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            <div className="bg-blue-700 px-8 py-6"><h2 className="text-3xl font-bold text-white">Recent Project Experience</h2></div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-gray-100"><tr><th className="px-8 py-5 text-left text-slate-900 font-bold">Project Name</th><th className="px-8 py-5 text-center text-slate-900 font-bold">Reinforcing Steel (LBS)</th></tr></thead>
                <tbody>{projects.map((project) => <tr key={project.name} className="border-b hover:bg-blue-50 transition"><td className="px-8 py-5 text-gray-700">{project.name}</td><td className="px-8 py-5 text-center font-semibold text-blue-700">{project.lbs}</td></tr>)}</tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-blue-700 py-20">
        <div className="max-w-5xl mx-auto text-center px-6">
          <h2 className="text-4xl font-bold text-white">Let's Build Your Next Project</h2>
          <p className="text-blue-100 mt-6 text-lg">We deliver accurate reinforcing steel estimation, detailing and quantity take-offs for projects of every size.</p>
          <button onClick={() => { window.location.href = "/contact"; }} className="mt-10 bg-amber-500 hover:bg-amber-600 text-white px-10 py-4 rounded-xl font-semibold text-lg transition">Request a Free Quote</button>
        </div>
      </section>
    </div>
  );
}

function Stat({ number, label }) {
  return <div className="bg-gray-50 rounded-2xl shadow-lg p-8 text-center"><h2 className="text-5xl font-bold text-amber-500">{number}</h2><p className="mt-4 text-gray-700 font-medium">{label}</p></div>;
}
